import { Directive } from '@angular/core';
import { WRxBase } from './w-rx-base';

@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class BemBlock extends WRxBase {
  abstract get blockPrefix(): string;
  blockClassName(suffix1: string, suffix2?: string) {
    return `${this.blockPrefix}__${suffix1}${suffix2 ? '--' + suffix2 : ''}`;
  }
}
